import moment from 'moment'
import { identity, ifElse } from 'ramda'
import { buildShopSearchForm } from '@pcln/home-components'
import { getComponentsFromTripType } from './getComponentsFromTripType'

const packagesSearch = ({
  roomCount = 1,
  adultCount = 2,
  childrenCount = 0,
  childrenAges = [],
  startDate = '',
  endDate = '',
  startLocationObject = undefined,
  endLocationObject = undefined,
  hotelStartDate = '',
  hotelEndDate = '',
  tripType = 'STAY:FLY',
  isPartialStayDateValid,
  isRecommendedTrip = false,
  ...rest
}) => {
  const url = '/shop/search/'
  const childrenAgesMock = {}
  childrenAges.forEach((item, i) => {
    const key = `child${++i}`
    childrenAgesMock[key] = item
  })

  const isLocationTypeGeo = locationObject => typeof locationObject.type === 'string' &&
    locationObject.type.toUpperCase() === 'GEO'

  // Package endpoint currently does not support searches by GEO type (i.e. with latitude and longitude)
  // Modifying the location object when it is selected through 'Use Current Location' feature of typeahead
  const updateLocationObjectForGeoType = locationObject => ({
    ...locationObject,
    ...(locationObject.cityID && {
      type: 'CITY',
      id: locationObject.cityID,
      displayName: locationObject.itemName,
      name: locationObject.itemName
    })
  })

  const searchRequest = {
    rooms: roomCount,
    adultCount,
    childCount: childrenCount,
    children: childrenAgesMock,
    departureDate: moment(startDate).format('MM/DD/YYYY'),
    departureLocation: ifElse(isLocationTypeGeo, updateLocationObjectForGeoType, identity)(startLocationObject || endLocationObject),
    returnDate: moment(endDate).format('MM/DD/YYYY'),
    arrivalLocation: ifElse(isLocationTypeGeo, updateLocationObjectForGeoType, identity)(endLocationObject),
    pivotComponentKey: 0,
    isRecommendedTrip,
    components: getComponentsFromTripType(tripType, {
      isPartialStayDateValid,
      hotelStartDate: moment(hotelStartDate).format('YYYY-MM-DD'),
      hotelEndDate: moment(hotelEndDate).format('YYYY-MM-DD'),
      roomCount,
      isCarRequired: tripType.includes('DRIVE'),
      ...rest
    })
  }

  const form = buildShopSearchForm(
    url,
    searchRequest
  )
  form.submit()
}

export default packagesSearch
